<script lang="ts" setup>
import type { PropType } from 'vue'
import type { TFilterItem, TFilterItemGroupedMultiselect } from '~/layers/catalog/data/types'
import {
  type TFilterStoring,
  type TFilterStoringOptions,
  TFilterStoringType,
} from '~/layers/catalog/composables/catalogFilter'
import { useCatalogFilter } from '~/layers/catalog/composables/catalogFilter'

const props = defineProps({
  filter: {
    type: Object as PropType<TFilterItemGroupedMultiselect & TFilterItem>,
    required: true,
  },
})

const service = useCatalogFilter()

const checkedOptions = computed(() => {
  const storing = service.get(props.filter?.code) as (TFilterStoring & TFilterStoringOptions) | null
  return storing?.options || []
})

const toggleOption = (option: string) => {
  const options = checkedOptions.value.includes(option)
    ? checkedOptions.value.filter((o) => o !== option)
    : [...checkedOptions.value, option]
  if (!options.length) {
    service.remove(props.filter.code)
    return
  }
  service.set(props.filter.code, { options, type: TFilterStoringType.Options })
}

const isEnabledRuValues = computed(() => {
  return useCatalogFilter().isEnabledRuValues(props.filter!.code)
})
</script>

<template>
  <div>
    <template v-for="group in filter.groups" :key="group.name">
      <div class="filters__value_subtitle" v-if="group.name && !isEnabledRuValues">{{ group.name }}</div>
      <template v-for="option in group.items" :key="option.code">
        <div class="filters__value" :class="option.disabled && checkedOptions.includes(option.code) && 'disabledAndChecked'" v-if="isEnabledRuValues ? option.isRuValue : !option.isRuValue">
          <label>
            <input
              :disabled="!checkedOptions.includes(option.code) && option.disabled"
              class="filters__value-input"
              type="checkbox"
              :checked="checkedOptions.includes(option.code)"
              @change="toggleOption(option.code)"
            />
            <p class="filters__value-text">{{ option.name }}</p>
          </label>
        </div>
      </template>
    </template>
  </div>
</template>
